module.exports = __webpack_public_path__ + "static/media/github.09375cf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/github.svg
// module id = 28
// module chunks = 0